module.exports = __webpack_public_path__ + "static/media/squared.d3b52e04.jpg";